import React from 'react';

import PropTypes from 'prop-types';

import DefaultSection from './Section';

const AccordionDetailsView = ({ cdSection = null, ...props }) => {
  switch (cdSection) {
    default:
      return <DefaultSection cdSection={cdSection} {...props} />;
  }
};

AccordionDetailsView.propTypes = {
  cdSection: PropTypes.string,
};

export default AccordionDetailsView;
